// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editGalleryModal__Rev4j {
  width: 890px;
  height: 750px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .editGalleryModal__Rev4j {
    width: 750px;
    height: 680px;
  }
}
@media (max-width: 800px) {
  .editGalleryModal__Rev4j {
    width: 675px;
    height: 584px;
  }
}

.modalBody__jFTx2 {
  height: 100%;
  padding: 20px 25px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
@media (max-width: 800px) {
  .modalBody__jFTx2 {
    padding: 10px 15px 5px;
    gap: 5px;
  }
}

.photoContainer__pNXwF,
.modalInfoLine__BPOfS {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  text-align: left;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 11px 25px 12px;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.upperBodyModal__T2et_ {
  gap: 20px;
  display: flex;
}
@media (max-width: 800px) {
  .upperBodyModal__T2et_ {
    gap: 10px;
  }
}

.lowerBodyModal__H0uDJ {
  width: 100%;
  display: flex;
  gap: 20px;
  position: relative;
  height: 162px;
  padding: 15px;
  background: var(--inputs-disable-disable-surface);
}
@media (max-width: 800px) {
  .lowerBodyModal__H0uDJ {
    height: 137px;
    gap: 10px;
  }
}

.twoBulletPagination__tVbiG .swiper-pagination {
  transform: translateX(-21%) !important;
}

.threeBulletPagination___tAqd .swiper-pagination {
  transform: translateX(-26%) !important;
}
@media (max-width: 1200px) {
  .threeBulletPagination___tAqd .swiper-pagination {
    transform: translateX(-31%) !important;
  }
}

.fourBulletPagination__PHVCO .swiper-pagination {
  transform: translateX(-32%) !important;
}

.fiveBulletPagination__bPRhj .swiper-pagination {
  transform: translateX(-45%) !important;
}

@media (max-width: 1200px) {
  .dynamicBullets__h3lIZ .swiper-pagination {
    transform: translateX(-64%) !important;
  }
}

.gallerySwiper__tA4XB {
  width: 100%;
  height: 162px;
  flex: 6;
  overflow: hidden;
}
@media (max-width: 800px) {
  .gallerySwiper__tA4XB {
    flex: 5;
    height: 142px;
    height: 137px;
  }
}
.gallerySwiper__tA4XB .swiper-pagination {
  display: flex;
  position: absolute;
  bottom: 36px !important;
  left: 42% !important;
  transform: translateX(-58%);
  z-index: 2;
}
@media (max-width: 800px) {
  .gallerySwiper__tA4XB .swiper-pagination {
    bottom: 25px !important;
  }
}
@media (max-width: 1200px) {
  .gallerySwiper__tA4XB .swiper-pagination {
    transform: translateX(-68%);
  }
}
.gallerySwiper__tA4XB .swiper-pagination-bullet {
  min-width: 16px;
  height: 3px;
  display: block;
  padding: 0;
  background: var(--tables-photo-gallery-pagination-default);
  transform: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  opacity: 1;
  cursor: pointer;
}
.gallerySwiper__tA4XB .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 11px;
  background: var(--tables-photo-gallery-pagination-active);
  border: none;
  cursor: auto;
}
.gallerySwiper__tA4XB .swiper-pagination-bullet-active-prev,
.gallerySwiper__tA4XB .swiper-pagination-bullet-active-next {
  transform: unset !important;
}
.gallerySwiper__tA4XB .swiper-pagination-bullet-active-prev-prev,
.gallerySwiper__tA4XB .swiper-pagination-bullet-active-next-next {
  transform: scaleX(0.3) !important;
}

.galleryButton__BBGks {
  width: 100px;
}

.slide__e20Ge {
  position: relative;
  height: 101px;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.addPhotoSlide__i8Suh {
  flex: 1;
  height: 102px;
}
@media (max-width: 1200px) {
  .addPhotoSlide__i8Suh {
    min-width: 115px;
  }
}

.galleryImage__P8WML {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.deleteImageIcon__PbYSf {
  position: absolute;
  right: 5px;
  top: 5px;
}
.deleteImageIcon__PbYSf rect {
  fill-opacity: 1;
  fill: var(--labels-filled-surface-archived);
}

.errorMessage__Cx0bL {
  height: 15px;
}
.errorMessage__Cx0bL span {
  font-size: 10px;
  font-weight: 400;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 15px;
}

.modalFooter__QTFJ7 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px 0;
  gap: 20px;
}
@media (max-width: 800px) {
  .modalFooter__QTFJ7 {
    padding: 5px;
  }
}

.navBtn__NjWpD {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tables-photo-gallery-surface-arrow);
  border: none;
  position: absolute;
  top: 34%;
  z-index: 1;
  cursor: pointer;
  right: 0;
}
.navBtn__NjWpD path {
  stroke: var(--tables-photo-gallery-icon);
}

.prevBtn__PBMbV {
  right: unset;
  left: 0;
  border-radius: 0 2px 2px 0;
}

.prevBtnIcon__U7GDa {
  width: 20px;
  height: 20px;
  transform: rotate(180deg);
}
.prevBtnIcon__U7GDa path {
  stroke: var(--tables-photo-gallery-icon);
}

.currentSlide__gPtM2 {
  border-radius: 2px;
  border: 2px solid var(--buttons-surface);
  background: var(--buttons-surface);
}
.currentSlide__gPtM2 img {
  opacity: 0.7;
}

.recoverImageBtn__Y_c8B {
  font-size: 12px;
  color: var(--buttons-surface);
  padding: 2px 4px;
  background: var(--tables-secondary-row-sub-title-surface);
  border-radius: 4px;
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 3;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditSensorGalleryModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAzEF;AA2EE;EANF;IAOI,YAAA;IACA,aAAA;EAxEF;AACF;AA0EE;EAXF;IAYI,YAAA;IACA,aAAA;EAvEF;AACF;;AA0EA;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvEF;AAyEE;EARF;IASI,sBAAA;IACA,QAAA;EAtEF;AACF;;AAyEA;;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,uBAAA;EACA,gDAAA;EACA,mDAAA;EACA,uCAAA;AAtEF;;AAyEA;EACE,SAAA;EACA,aAAA;AAtEF;AAwEE;EAJF;IAKI,SAAA;EArEF;AACF;;AAwEA;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,iDAAA;AArEF;AAuEE;EATF;IAUI,aAAA;IACA,SAAA;EApEF;AACF;;AAyEI;EACE,sCAAA;AAtEN;;AA6EI;EACE,sCAAA;AA1EN;AA4EM;EAHF;IAII,sCAAA;EAzEN;AACF;;AAgFI;EACE,sCAAA;AA7EN;;AAoFI;EACE,sCAAA;AAjFN;;AAyFM;EADF;IAEI,sCAAA;EArFN;AACF;;AA0FA;EACE,WAAA;EACA,aAAA;EAEA,OAAA;EACA,gBAAA;AAxFF;AA0FE;EAPF;IAQI,OAAA;IACA,aAAA;IACA,aAAA;EAvFF;AACF;AA0FI;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;AAxFN;AA0FM;EARF;IASI,uBAAA;EAvFN;AACF;AAyFM;EAZF;IAaI,2BAAA;EAtFN;AACF;AAyFI;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,0DAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAvFN;AAyFM;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,YAAA;AAvFR;AA0FI;;EAEE,2BAAA;AAxFN;AA2FI;;EAEE,iCAAA;AAzFN;;AA8FA;EACE,YAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA3FF;;AA8FA;EACE,OAAA;EACA,aAAA;AA3FF;AA6FE;EAJF;IAKI,gBAAA;EA1FF;AACF;;AA6FA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA1FF;;AA6FA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA1FF;AA4FE;EACE,eAAA;EACA,2CAAA;AA1FJ;;AA8FA;EACE,YAAA;AA3FF;AA6FE;EACE,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AA3FJ;;AA+FA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AA5FF;AA8FE;EARF;IASI,YAAA;EA3FF;AACF;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2DAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;AA3FF;AA6FE;EACE,wCAAA;AA3FJ;;AA+FA;EACE,YAAA;EACA,OAAA;EACA,0BAAA;AA5FF;;AA+FA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AA5FF;AA8FE;EACE,wCAAA;AA5FJ;;AAgGA;EACE,kBAAA;EACA,wCAAA;EACA,kCAAA;AA7FF;AA+FE;EACE,YAAA;AA7FJ;;AAiGA;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,yDAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AA9FF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editGalleryModal {\n  width: 890px;\n  height: 750px;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    width: 750px;\n    height: 680px;\n  }\n\n  @media (max-width: 800px) {\n    width: 675px;\n    height: 584px;\n  }\n}\n\n.modalBody {\n  height: 100%;\n  padding: 20px 25px 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n\n  @media (max-width: 800px) {\n    padding: 10px 15px 5px;\n    gap: 5px;\n  }\n}\n\n.photoContainer,\n.modalInfoLine {\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 14px;\n  text-align: left;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n  padding: 11px 25px 12px;\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.upperBodyModal {\n  gap: 20px;\n  display: flex;\n\n  @media (max-width: 800px) {\n    gap: 10px;\n  }\n}\n\n.lowerBodyModal {\n  width: 100%;\n  display: flex;\n  gap: 20px;\n  position: relative;\n  height: 162px;\n  padding: 15px;\n  background: var(--inputs-disable-disable-surface);\n\n  @media (max-width: 800px) {\n    height: 137px;\n    gap: 10px;\n  }\n}\n\n.twoBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-21%) !important;\n    }\n  }\n}\n\n.threeBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-26%) !important;\n\n      @media (max-width: 1200px) {\n        transform: translateX(-31%) !important;\n      }\n    }\n  }\n}\n\n.fourBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-32%) !important;\n    }\n  }\n}\n\n.fiveBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-45%) !important;\n    }\n  }\n}\n\n.dynamicBullets {\n  :global {\n    .swiper-pagination {\n      @media (max-width: 1200px) {\n        transform: translateX(-64%) !important;\n      }\n    }\n  }\n}\n\n.gallerySwiper {\n  width: 100%;\n  height: 162px;\n\n  flex: 6;\n  overflow: hidden;\n\n  @media (max-width: 800px) {\n    flex: 5;\n    height: 142px;\n    height: 137px;\n  }\n\n  :global {\n    .swiper-pagination {\n      display: flex;\n      position: absolute;\n      bottom: 36px !important;\n      left: 42% !important;\n      transform: translateX(-58%);\n      z-index: 2;\n\n      @media (max-width: 800px) {\n        bottom: 25px !important;\n      }\n\n      @media (max-width: 1200px) {\n        transform: translateX(-68%);\n      }\n    }\n\n    .swiper-pagination-bullet {\n      min-width: 16px;\n      height: 3px;\n      display: block;\n      padding: 0;\n      background: var(--tables-photo-gallery-pagination-default);\n      transform: none;\n      border: none;\n      border-radius: 0;\n      box-shadow: none;\n      opacity: 1;\n      cursor: pointer;\n\n      &.swiper-pagination-bullet-active {\n        width: 11px;\n        background: var(--tables-photo-gallery-pagination-active);\n        border: none;\n        cursor: auto;\n      }\n    }\n    .swiper-pagination-bullet-active-prev,\n    .swiper-pagination-bullet-active-next {\n      transform: unset !important;\n    }\n\n    .swiper-pagination-bullet-active-prev-prev,\n    .swiper-pagination-bullet-active-next-next {\n      transform: scaleX(0.3) !important;\n    }\n  }\n}\n\n.galleryButton {\n  width: 100px;\n}\n\n.slide {\n  position: relative;\n  height: 101px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.addPhotoSlide {\n  flex: 1;\n  height: 102px;\n\n  @media (max-width: 1200px) {\n    min-width: 115px;\n  }\n}\n\n.galleryImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.deleteImageIcon {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n\n  rect {\n    fill-opacity: 1;\n    fill: var(--labels-filled-surface-archived);\n  }\n}\n\n.errorMessage {\n  height: 15px;\n\n  span {\n    font-size: 10px;\n    font-weight: 400;\n    color: var(--inputs-error-text-helper);\n    margin-top: 4px;\n    min-height: 15px;\n  }\n}\n\n.modalFooter {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 15px 0;\n  gap: 20px;\n\n  @media (max-width: 800px) {\n    padding: 5px;\n  }\n}\n\n.navBtn {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--tables-photo-gallery-surface-arrow);\n  border: none;\n  position: absolute;\n  top: 34%;\n  z-index: 1;\n  cursor: pointer;\n  right: 0;\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n}\n\n.prevBtn {\n  right: unset;\n  left: 0;\n  border-radius: 0 2px 2px 0;\n}\n\n.prevBtnIcon {\n  width: 20px;\n  height: 20px;\n  transform: rotate(180deg);\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n}\n\n.currentSlide {\n  border-radius: 2px;\n  border: 2px solid var(--buttons-surface);\n  background: var(--buttons-surface);\n\n  img {\n    opacity: 0.7;\n  }\n}\n\n.recoverImageBtn {\n  font-size: 12px;\n  color: var(--buttons-surface);\n  padding: 2px 4px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border-radius: 4px;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  z-index: 3;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editGalleryModal": `editGalleryModal__Rev4j`,
	"modalBody": `modalBody__jFTx2`,
	"photoContainer": `photoContainer__pNXwF`,
	"modalInfoLine": `modalInfoLine__BPOfS`,
	"upperBodyModal": `upperBodyModal__T2et_`,
	"lowerBodyModal": `lowerBodyModal__H0uDJ`,
	"twoBulletPagination": `twoBulletPagination__tVbiG`,
	"threeBulletPagination": `threeBulletPagination___tAqd`,
	"fourBulletPagination": `fourBulletPagination__PHVCO`,
	"fiveBulletPagination": `fiveBulletPagination__bPRhj`,
	"dynamicBullets": `dynamicBullets__h3lIZ`,
	"gallerySwiper": `gallerySwiper__tA4XB`,
	"galleryButton": `galleryButton__BBGks`,
	"slide": `slide__e20Ge`,
	"addPhotoSlide": `addPhotoSlide__i8Suh`,
	"galleryImage": `galleryImage__P8WML`,
	"deleteImageIcon": `deleteImageIcon__PbYSf`,
	"errorMessage": `errorMessage__Cx0bL`,
	"modalFooter": `modalFooter__QTFJ7`,
	"navBtn": `navBtn__NjWpD`,
	"prevBtn": `prevBtn__PBMbV`,
	"prevBtnIcon": `prevBtnIcon__U7GDa`,
	"currentSlide": `currentSlide__gPtM2`,
	"recoverImageBtn": `recoverImageBtn__Y_c8B`
};
module.exports = ___CSS_LOADER_EXPORT___;
